/**
 * Session id used to correlate a visitor's `/api/chat` requests with their
 * PostHog experiment assignment. Reads the proxy-set `ahead-experiment-id`
 * cookie, falling back to a random id only in the narrow window before the
 * proxy has run.
 *
 * `crypto.randomUUID()` is a runtime-only call (lazy, at send time), which
 * avoids the `Math.random()` path Next 16 flags as non-deterministic during
 * prerender analysis. Shared by `chat-panel.tsx` and `use-ai-answer.ts`.
 */
export function getSessionId(): string {
  if (typeof document === "undefined") return "srv"
  const m = document.cookie.match(/(?:^|;\s*)ahead-experiment-id=([^;]+)/)
  return m ? decodeURIComponent(m[1]) : `fallback-${crypto.randomUUID()}`
}
